import "bootstrap";
import "slick-carousel";
import "readmore-js";
import "./froogaloop2.min";

(function ($) {
  // On Dom Ready
  $(function () {
    // Toggle Mobile Menu
    $(".menu-open").on("click", function (e) {
      e.preventDefault();
      $(".menu-open").toggleClass("is-active");
      $(".mobile-menu-wrapper").toggleClass("active");
      $("body").toggleClass("noscroll");
    });

    if (window.innerWidth <= 768) {
      // Open Mobile Menu Sub Menu
      $(".mobile-menu-wrapper ul.mobile__main-menu > li.sixth-form > span.icon-arrow").on("click", function (e) {
        e.preventDefault();
        $(".mega-menu.sixth-form").addClass("active");
      });
      $(".mobile-menu-wrapper ul.mobile__main-menu > li.apprenticeships > span.icon-arrow").on("click", function (e) {
        e.preventDefault();
        $(".mega-menu.apprenticeships").addClass("active");
      });
      $(".mobile-menu-wrapper ul.mobile__main-menu > li.international > span.icon-arrow").on("click", function (e) {
        e.preventDefault();
        $(".mega-menu.international").addClass("active");
      });
      $(".mobile-menu-wrapper ul.mobile__main-menu > li.adult-learning > span.icon-arrow").on("click", function (e) {
        e.preventDefault();
        $(".mega-menu.adult-learning").addClass("active");
      });
      $(".mobile-menu-wrapper ul.mobile__main-menu > li.parent-information > span.icon-arrow").on("click", function (e) {
        e.preventDefault();
        $(".mega-menu.parent-information").addClass("active");
      });
      $(".mobile-menu-wrapper ul.mobile__main-menu > li.community > span.icon-arrow").on("click", function (e) {
        e.preventDefault();
        $(".mega-menu.community").addClass("active");
      });
      $(".mobile-menu-wrapper ul.mobile__main-menu > li.about > span.icon-arrow").on("click", function (e) {
        e.preventDefault();
        $(".mega-menu.about").addClass("active");
      });

      // Close Mobile Menu Sub Menu
      $(".mega-menu .the-title").on("click", function (e) {
        e.preventDefault();
        $(".mega-menu").removeClass("active");
      });

      // Toggle Mega Menu Sub Menu Mobile
      $(".mega-menu ul.mega-menu__main > li.menu-item-has-children > span.icon-arrow").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("active");
        /* $(this).next().slideToggle(); */
        $(this).next().toggleClass("active");
      });
    }

    // Mega Menu Toggle
    /* $(".header__main-menu ul li.has-megamenu").on({
      mouseenter: function () {
        $(this).addClass("active");
        if ($(this).hasClass("sixth-form")) {
          $(".mega-menu.sixth-form").addClass("active");
        } else if ($(this).hasClass("international")) {
          $(".mega-menu.international").addClass("active");
        } else if ($(this).hasClass("adult-learning")) {
          $(".mega-menu.adult-learning").addClass("active");
        } else if ($(this).hasClass("apprenticeships")) {
          $(".mega-menu.apprenticeships").addClass("active");
        } else if ($(this).hasClass("parent-information")) {
          $(".mega-menu.parent-information").addClass("active");
        } else if ($(this).hasClass("community")) {
          $(".mega-menu.community").addClass("active");
        } else if ($(this).hasClass("about")) {
          $(".mega-menu.about").addClass("active");
        }
      },
      mouseleave: function () {
        $(this).removeClass("active");
        $(".mega-menu").removeClass("active");
      },
    }); */

    $(".header__main-menu ul li.has-megamenu").hoverIntent({
      over: function () {
        $(this).addClass("active");
        if ($(this).hasClass("sixth-form")) {
          $(".mega-menu.sixth-form").addClass("active");
        } else if ($(this).hasClass("international")) {
          $(".mega-menu.international").addClass("active");
        } else if ($(this).hasClass("adult-learning")) {
          $(".mega-menu.adult-learning").addClass("active");
        } else if ($(this).hasClass("apprenticeships")) {
          $(".mega-menu.apprenticeships").addClass("active");
        } else if ($(this).hasClass("parent-information")) {
          $(".mega-menu.parent-information").addClass("active");
        } else if ($(this).hasClass("community")) {
          $(".mega-menu.community").addClass("active");
        } else if ($(this).hasClass("about")) {
          $(".mega-menu.about").addClass("active");
        }
      },
      out: function () {
        $(this).removeClass("active");
        $(".mega-menu").removeClass("active");
      },
    });

    /* $(".mega-menu .container").on({
      mouseenter: function () {
        $(this).parent().addClass("active");

        if ($(this).parent().hasClass("sixth-form")) {
          $(".header__main-menu ul li.has-megamenu.sixth-form").addClass("active");
        } else if ($(this).parent().hasClass("international")) {
          $(".header__main-menu ul li.has-megamenu.international").addClass("active");
        } else if ($(this).parent().hasClass("adult-learning")) {
          $(".header__main-menu ul li.has-megamenu.adult-learning").addClass("active");
        } else if ($(this).parent().hasClass("appernticeships")) {
          $(".header__main-menu ul li.has-megamenu.appernticeships").addClass("active");
        } else if ($(this).parent().hasClass("parent-information")) {
          $(".header__main-menu ul li.has-megamenu.parent-information").addClass("active");
        } else if ($(this).parent().hasClass("community")) {
          $(".header__main-menu ul li.has-megamenu.community").addClass("active");
        } else if ($(this).parent().hasClass("about")) {
          $(".header__main-menu ul li.has-megamenu.about").addClass("active");
        }
      },
      mouseleave: function () {
        $(this).parent().removeClass("active");

        if ($(this).parent().hasClass("sixth-form")) {
          $(".header__main-menu ul li.has-megamenu.sixth-form").removeClass("active");
        }
        if ($(this).parent().hasClass("international")) {
          $(".header__main-menu ul li.has-megamenu.international").removeClass("active");
        }
        if ($(this).parent().hasClass("adult-learning")) {
          $(".header__main-menu ul li.has-megamenu.adult-learning").removeClass("active");
        }
        if ($(this).parent().hasClass("apprenticeships")) {
          $(".header__main-menu ul li.has-megamenu.apprenticeships").removeClass("active");
        }
        if ($(this).parent().hasClass("parent-information")) {
          $(".header__main-menu ul li.has-megamenu.parent-information").removeClass("active");
        }
        if ($(this).parent().hasClass("community")) {
          $(".header__main-menu ul li.has-megamenu.community").removeClass("active");
        }
        if ($(this).parent().hasClass("about")) {
          $(".header__main-menu ul li.has-megamenu.about").removeClass("active");
        }
      },
    }); */

    $(".mega-menu .container").hoverIntent({
      interval: 0,
      over: function () {
        $(this).parent().addClass("active");

        if ($(this).parent().hasClass("sixth-form")) {
          $(".header__main-menu ul li.has-megamenu.sixth-form").addClass("active");
        } else if ($(this).parent().hasClass("international")) {
          $(".header__main-menu ul li.has-megamenu.international").addClass("active");
        } else if ($(this).parent().hasClass("adult-learning")) {
          $(".header__main-menu ul li.has-megamenu.adult-learning").addClass("active");
        } else if ($(this).parent().hasClass("appernticeships")) {
          $(".header__main-menu ul li.has-megamenu.appernticeships").addClass("active");
        } else if ($(this).parent().hasClass("parent-information")) {
          $(".header__main-menu ul li.has-megamenu.parent-information").addClass("active");
        } else if ($(this).parent().hasClass("community")) {
          $(".header__main-menu ul li.has-megamenu.community").addClass("active");
        } else if ($(this).parent().hasClass("about")) {
          $(".header__main-menu ul li.has-megamenu.about").addClass("active");
        }
      },
      out: function () {
        $(this).parent().removeClass("active");

        if ($(this).parent().hasClass("sixth-form")) {
          $(".header__main-menu ul li.has-megamenu.sixth-form").removeClass("active");
        }
        if ($(this).parent().hasClass("international")) {
          $(".header__main-menu ul li.has-megamenu.international").removeClass("active");
        }
        if ($(this).parent().hasClass("adult-learning")) {
          $(".header__main-menu ul li.has-megamenu.adult-learning").removeClass("active");
        }
        if ($(this).parent().hasClass("apprenticeships")) {
          $(".header__main-menu ul li.has-megamenu.apprenticeships").removeClass("active");
        }
        if ($(this).parent().hasClass("parent-information")) {
          $(".header__main-menu ul li.has-megamenu.parent-information").removeClass("active");
        }
        if ($(this).parent().hasClass("community")) {
          $(".header__main-menu ul li.has-megamenu.community").removeClass("active");
        }
        if ($(this).parent().hasClass("about")) {
          $(".header__main-menu ul li.has-megamenu.about").removeClass("active");
        }
      },
    });

    // Intro Carousel
    $(".welcome .the-carousel").slick({
      autoplay: false,
      autoplaySpeed: 3000,
      dots: false,
      arrows: true,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      rows: 0,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg></button>',
    });
    $(".welcome .the-carousel").on("beforeChange", function (slick, currentSlide, nextSlide) {
      var player, command;

      //find the current slide element and decide which player API we need to use.
      currentSlide = $(".welcome .the-carousel").find(".slick-current");

      //get the iframe inside this slide.
      player = currentSlide.find("iframe").get(0);
      if ($(player).hasClass("video-youtube")) {
        // console.log({ player });

        command = {
          event: "command",
          func: "pauseVideo",
        };

        //check if the player exists.
        if (player != undefined) {
          //post our command to the iframe.
          player.contentWindow.postMessage(JSON.stringify(command), "*");
        }
      } else if ($(player).hasClass("video-vimeo")) {
        var vimeoPlayer = $f(player);
        vimeoPlayer.api("pause");
      }
    });

    // Home banner Carousel
    $(".home-banner-carousel .the-carousel").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      rows: 0,
      fade: true,
    });

    // Student voice Carousel
    $(".student-voice .the-carousel").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: true,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      rows: 0,
    });

    // Gallery Carousel
    $(".gallery-carousel.the-carousel").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      arrows: true,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      rows: 0,
      lazyLoad: "ondemand",
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg></button>',
    });

    // You may also like courses carousel
    $(".related-courses .the-carousel").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      arrows: true,
      infinite: true,
      speed: 700,
      slidesToShow: 3,
      slidesToScroll: 3,
      adaptiveHeight: true,
      rows: 0,
      lazyLoad: "ondemand",
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg></button>',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
          },
        },
        {
          breakpoint: 579,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
          },
        },
      ],
    });

    // Intro Content Readmore
    $(".the-intro-content").readmore({
      speed: 75,
      moreLink: '<a href="#">Read more &gt;</a>',
      lessLink: '<a href="#">Read less &gt;</a>',
      collapsedHeight: 425,
    });

    // Toggle collapsible block
    $(".collapsible-blocks .the-block__title").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(this).next().slideToggle();
      if ($(this).next().find(".gallery-carousel.the-carousel")) {
        $(".gallery-carousel.the-carousel").slick("refresh");
      }
    });

    // Toggle inner dropdown menu
    $(".page-header__subtitle.has-dropdown").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(".inner-dropdown-menu").toggleClass("active");
    });

    // Toggle footer widgets
    if (window.innerWidth <= 767) {
      $(".footer__title.no-mb").on("click", function (e) {
        e.preventDefault();
        $(this).next().slideToggle();
      });
    } else {
      $(".footer__title.no-mb").slideDown();
    }

    // Get faculty levels helper
    function get_faculty_levels(faculty_id) {
      const request_data = {
        action: "get_faculty_levels",
        faculty_id: faculty_id,
      };

      $(".ajax-content-wrapper .loading").show();

      $.ajax({
        type: "POST",
        url: ajax_object.ajax_url,
        data: request_data,
        success: function (response) {
          $("#coursesList").html("");
          $("#levelsList").html(response);
          $(".ajax-content-wrapper .loading").hide();
        },
        error: function (msg) {
          console.log("error", msg);
          $(".ajax-content-wrapper .loading").hide();
        },
      });
    }

    // Get courses helper
    /* function get_courses(faculty_id = "", level_id = "") {
      const request_data = {
        action: "get_courses",
      };

      if (faculty_id) {
        request_data.faculty_id = faculty_id;
      }
      if (level_id) {
        request_data.level_id = level_id;
      }

      $(".ajax-content-wrapper .loading").show();

      $.ajax({
        type: "POST",
        url: ajax_object.ajax_url,
        data: request_data,
        success: function (response) {
          $("#coursesList").html(response);
          $(".ajax-content-wrapper .loading").hide();
        },
        error: function (msg) {
          console.log("error", msg);
          $(".ajax-content-wrapper .loading").hide();
        },
      });
    } */

    // get levels based on selected faculty
    /* $(".faculties-list.has-ajax a.color-link").on("click", function (e) {
      e.preventDefault();
      const faculty_id = $(this).data("faculty_id");
      get_faculty_levels(faculty_id);

      $(".faculties-list.has-ajax a.color-link").addClass("dimmed");
      $(this).removeClass("dimmed");

      get_courses(faculty_id);
    }); */

    /* $(document).on("click", ".levels-list .level", function (e) {
      e.preventDefault();
      const faculty_id = $(this).data("faculty_id");
      const level_id = $(this).data("level_id");
      get_courses(faculty_id, level_id);
      $(".levels-list .level").addClass("dimmed");
      $(this).removeClass("dimmed");
    }); */

    // Filer Courses
    $(".faculties-list .faculty-link").on("click", function (e) {
      e.preventDefault();
      let faculty_id = $(this).data("faculty_id");

      if ($(this).hasClass("active")) {
        $(".faculties-list .faculty-link").removeClass("active");
        $(".courses-list .color-link").removeClass("d-none");
        $(".courses-list .color-link").removeClass("d-flex");
        $(".courses-list .color-link").addClass("d-flex");
      } else {
        $(".faculties-list .faculty-link").removeClass("active");
        $(this).addClass("active");

        $(".courses-list .color-link").removeClass("d-flex");
        $(".courses-list .color-link").addClass("d-none");
        $(".courses-list .color-link.faculty-" + faculty_id).addClass("d-flex");
      }
    });

    // Upcoming events carousel
    $(".upcoming-events .carousel").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: false,
      variableWidth: true,
      lazyLoad: "ondemand",
      rows: 0,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg></button>',
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 991,
          settings: "unslick",
        },
      ],
    });

    // Latest News carousel
    $(".latest-news .carousel").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      dots: false,
      variableWidth: true,
      lazyLoad: "ondemand",
      rows: 0,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!--! Font Awesome Pro 6.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg></button>',
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: "unslick",
        },
      ],
    });

    // Lined boxes carousel
    $(".welcome .lined-boxes-carousel").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      lazyLoad: "ondemand",
      rows: 0,
    });

    $(window).on("resize", function () {
      $(".latest-news .carousel").slick("resize");
    });
  });
})(jQuery);
